import { render, staticRenderFns } from "./AccountReplication.vue?vue&type=template&id=e83191a8&scoped=true&"
import script from "./AccountReplication.vue?vue&type=script&lang=js&"
export * from "./AccountReplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83191a8",
  null
  
)

export default component.exports